export default {"card":"kmEc3","title":"VPjcD","videoWrapper":"xWCTn","videoContent":"_1SPfc","playButton":"aYc9u","duration":"kMMMZ","glow":"H0eba"};